import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BaseItemContrastOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-contrast-option';
import {useAppSelector} from '@/hooks';
import {BackgroundTypeName} from "@PosterWhiteboard/page/background/background.types";

export function ImageBgContrastOption(): ReactElement<any> | null {
  const currentPageBackground = useAppSelector(getCurrentPageBackground);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const imageDetails = currentPageBackground.details;

  const updateContrast = (contrast: number, undoable?: boolean): void => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          effects: {
            contrast,
          },
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemContrastOption contrast={imageDetails.effects.contrast} updateContrast={updateContrast} />;
}
